import { ComponentConfig } from '@measured/puck';
import {
  UpSell as UpSellComponent,
  UpSellProps,
} from '../components/upsell/Upsell';
import { ReduxDispatchProps, ReduxSelectorProps } from '../services/constants';
import {
  TermsAndSub as TermsAndSubComponent,
  TermsAndSubProps,
} from '../components/terms-and-subscription';
import {
  Header as HeaderComponent,
  HeaderProps,
} from '../components/post-upsell/header/Header';
import {
  Payment as PaymentComponent,
  PaymentProps,
} from '../components/payment/Payment';
import { VipComponent as Vip, VipComponentProps } from '../components/vip';
import {
  CarouselReview as CarouselReviewComponent,
  CarouselReviewProps,
} from '../components/carousel review';
import {
  SingleProduct as ProductComponent,
  SingleProductProps,
} from '../components/post-upsell/product-varient';

import { StarProps, Startrate } from '../components/star-rating';
import {
  StandardLayout as StandardLayoutComponent,
  StandardLayoutProps,
} from '../components/blocks/StandardLayout';
import {
  ShippingMethodSelect as ShippingMethodSelectComponent,
  ShippingMethodSelectProps,
} from '../components/shipping-method/ShippingMethod';
import {
  SavingCalculatorProps,
  SavingCalculator as SavingCalculatorComponent,
} from '../components/savings-calculator';
import {
  PromoCodeProps,
  PromoCode as PromoCodeComponent,
} from '../components/promo-code/PromoCode';
import {
  PaymentRadioProps,
  PaymentRadio as PaymentRadioComponent,
} from '../components/payment-radio/PaymentRadio';
import {
  SimplePageHeaderProps,
  SimplePageHeader as SimplePageHeaderComponent,
} from '../components/page-headers/SimplePageHeader';
import {
  OrderDetailsProps,
  OrderDetails as OrderDetailsComponent,
} from '../components/order-details/OrderDetails';
import {
  ContactInfoProps,
  ContactInfo as ContactInfoComponent,
} from '../components/contact-info/ContactInfo';
import { Cart as CartComponent, CartProps } from '../components/cart';
import {
  SingleStepButtonSectionProps,
  SingleStepButtonSection as ConfirmPurchaseComponent,
} from '../components/button-section/SingleStepButtonSection';
import {
  ConfirmPurchaseTCProps,
  ConfirmPurchaseTC as ConfirmPurchaseTCComponent,
} from '../components/button-section/ConfirmPurchaseTC';
import {
  ReturnButtonProps,
  ReturnButton as ReturnButtonComponent,
} from '../components/button-section/ReturnButton';
import {
  SingleProductAcceptButtonProps,
  SingleProductAcceptButton as SingleProductAcceptButtonComponent,
} from '../components/post-upsell/deal';
import {
  DeclineButtonProps,
  DeclineButton as NextButtonComponent,
} from '../components/post-upsell/next-button/next-button';
import {
  MultiProductAcceptButtonComponentPropsProps,
  MultiProductAcceptButton as MultiProductAcceptButtonComponent,
} from '../components/post-upsell/MultiProductAcceptButtom';
import {
  AlwaysVipProps,
  AlwaysVip as AlwaysVipComponent,
} from '../components/always-vip';
import {
  ShippingForm,
  ShippingForm as ShippingFormComponent,
} from '../components/address/ShippingForm';
import {
  FirstLastNameProps,
  FirstNameLastName as FirstLastNameComponent,
} from '../components/address/firstAndLastName';
import {
  PhoneNumberFieldProps,
  PhoneNumberField as PhoneNumberFieldComponent,
} from '../components/phoneNumber/PhoneNumber';
import {
  SplitLayoutProps,
  SplitLayout as SplitLayoutComponent,
} from '../components/blocks/SplitLayout';
import {
  ButtonSectionProps,
  ButtonComponent as ButtonComponent,
} from '../components/blocks/button/button';
import { AxiosInstance } from 'axios';
import {
  CustomerGuarnteesProps,
  CustomerGuarantees as CustomerGuarnteesComponent,
} from '../components/customer-guarantees/customerGuarantees';
import {
  ImageUploaderProps,
  ImageUploader as ImageUploaderComponent,
} from '../components/image-uploader/image-uploader';
import {
  Columns as ColumnComponent,
  ColumnsProps,
} from '../components/blocks/Columns';
import {
  FlexInternal,
  FlexProps as newFlexProps,
} from '../components/blocks/NewFlex';
import {
  VerticalSpace as VerticalSpaceComponent,
  VerticalSpaceProps,
} from '../components/blocks/VerticalSpace';
import {
  Divider as DividerComponent,
  DividerProps,
} from '../components/blocks/Divider';
import {
  Container as ContainerComponent,
  ContainerProps,
} from '../components/blocks/Container';
import {
  TextEditor as TextEditorComponent,
  TextEditorProps,
} from '../components/text-editor/TextEditor';
import {
  TextField as TextFieldComponent,
  TextFieldProps,
} from '../components/text-field/TextField';
import {
  BillingForm,
  BillingFormProps,
} from '../components/address/BillingForm';
import {
  CustomerReviews as CustomerReviewsComponent,
  CustomerReviewsProps,
} from '../components/customer-reviews/CustomerReviews';
import { Timer as TimerComponent, TimerProps } from '../components/timer/Timer';
import {
  NewTimer as NewTimerComponent,
  NewTimerProps,
} from '../components/New-Timer';
import { baseService as checkoutService } from '../api';
import {
  OrderSummary as OrderSummaryComponent,
  OrderSummaryProps,
} from '../components/order-summary/OrderSummary';
import {
  PostUpsellOrderSummary as PostUpsellOrderSummaryComponent,
  PostUpsellOrderSummaryProps,
} from '../components/order-summary/postUpsellOrderSummary/PostUpsellOrderSummary';
import {
  UserComponent,
  UserSectionProps,
} from '../components/usersDetails/Users';
import {
  GeneralTerms as General,
  GeneralTermsProps,
} from '../components/GeneralTerms';
import { Footer, FooterProps } from '../components/footer/footer';
import {
  SocialMediaIcon,
  SocialMediaProps,
} from '../components/social-media-icon/socialMedia';
import {
  HeaderMenuProps,
  HeaderMenu as HeaderMenuComponent,
} from '../components/page-headers/headerMenu';
import {
  ShipmentUpSell,
  ShipmentUpSellProps,
} from '../components/shipment-upsells';
import { CheckBox, CheckBoxProps } from '../components/check-box';
import {
  TermsAndCondition as TermsAndConditionComponent,
  TermsAndConditionProps,
} from '../components/TermsAndCondition';
import {
  NewsLetterFieldProps,
  NewsLetter as NewsLetterComponent,
} from '../components/news-letter';
import {
  TabContentProps,
  TabContent as TabContentComponent,
} from '../components/tabContent';
import { withLayout } from '../components/Layout';
import { GridInternal, GridProps } from '../components/blocks/Grid';
import { Flex as FlexComponent, FlexProps } from '../components/blocks/Flex';
import AccordionComponent, { IAccordionProps } from '../components/accordion';
import { TextBanner, TextBannerProps } from '../components/text-banner';
import {
  ApplePayButton as ApplePayButtonComponent,
  ApplePayButtonProps,
} from '../components/button-section/applePay-button';
import {
  GooglePay as GooglePayButtonComponent,
  GooglePayButtonProps,
} from '../components/button-section/GooglePay';
import {
  ProductVarientSelectionProps,
  ProductVarientSelection as ProductVariantSelectionComponent,
} from '../components/post-upsell/product-varient-selection/ProductVarientSelection';
import {
  FAQDisclosureSectionProps,
  FAQDisclosureSection as FAQDisclosureSectionComponent,
} from '../components/post-upsell/FAQ-Disclosure-Section';
import {
  QuantityComponent,
  QuantityProps,
} from '../components/post-upsell/quantity';
// Commented out this import because the slider component is only used on the upsell page of the Carticenyc store, and we are removing it for bundle optimization.
// import { ReviewSlider, ReviewProps } from '../components/Slider';
import {
  MultiProduct as ProductCardComponent,
  MultiProductProps,
} from '../components/post-upsell/products';

import { CarouselPanel, CarouselPanelProps } from '../components/carouselPanel';
import {
  CarouselContainer as CarouselContainerComponent,
  CarouselContainerProps,
} from '../components/carouselContainer';
import {
  PredefinedProps,
  Predefined as PredefinedComponent,
} from '../components/predefinedComponents';
import {
  PayPal as PayPalComponent,
  PayPalButtonProps,
} from '../components/button-section/Paypal-button';
import { GoogleMap, GoogleMapProps } from '../components/google-map-pin';
import { HoverTooltip, HoverTooltipProps } from '../components/hover-tooltip';
import {
  GiftProductTimer as GiftProductTimerComponent,
  GiftProductTimerProps,
} from '../components/Gift-product-timer';
import {
  TextDropdown as TextDropdownComponent,
  TextDropdownProps,
} from '../components/Text-Dropdown/TextDropdown';
import {
  SMSMarketing as SMSMarketingComponent,
  SMSMarketingProps,
} from '../components/SMS Marketing';
import {
  CarouselImage as CarouselImageComponent,
  CarouselImageProps,
} from '../components/carouselImage';
import {
  PredefinedPropsForUpsell,
  PredefinedUpsell as PredefinedComponentForUpsell,
} from '../components/predefinedComponentForUpsell';
import {
  CustomHTMLProps,
  CustomHTML as CustomHTMLComponent,
} from '../components/CustomHTML';
import {
  TicketsEntryMultiplierProps,
  TicketsEntryMultiplier as TicketsEntryMultiplierComponent,
} from '../components/monthly-multiplier/TicketsEntryMultiplier';
import { VideoPlayer, VideoPlayerProps } from '../components/videoPlayer';

interface CreateComponentConfigsArgs
  extends ReduxDispatchProps,
    ReduxSelectorProps {
  type: 'checkout' | 'thankyou' | 'upsell' | 'freestyle' | 'all';
  baseService?: AxiosInstance;
}

export const createComponentConfigs = ({
  useAppDispatch,
  useAppSelector,
  type,
  baseService = checkoutService,
}: CreateComponentConfigsArgs) => {
  const UpSell: ComponentConfig<UpSellProps> = withLayout(
    UpSellComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const Header: ComponentConfig<HeaderProps> = withLayout(
    HeaderComponent({
      useAppSelector,
    }),
  );
  const Columns: ComponentConfig<ColumnsProps> = ColumnComponent({
    useAppSelector,
  });
  const Flex: ComponentConfig<FlexProps> = withLayout(
    FlexComponent({
      useAppSelector,
    }),
  );
  const Accordion: ComponentConfig<IAccordionProps> = AccordionComponent({
    useAppSelector,
  });
  const NewFlex: ComponentConfig<newFlexProps> = withLayout(
    FlexInternal({
      useAppSelector,
    }),
  );
  const Grid: ComponentConfig<GridProps> = withLayout(
    GridInternal({
      useAppSelector,
    }),
  );
  const VerticalSpace: ComponentConfig<VerticalSpaceProps> = withLayout(
    VerticalSpaceComponent({
      useAppSelector,
    }),
  );
  const Container: ComponentConfig<ContainerProps> = ContainerComponent({
    useAppSelector,
    baseService,
  });
  const Divider: ComponentConfig<DividerProps> = withLayout(
    DividerComponent({
      useAppSelector,
    }),
  );
  const TextEditor: ComponentConfig<TextEditorProps> = withLayout(
    TextEditorComponent({
      useAppSelector,
    }),
  );
  const TextField: ComponentConfig<TextFieldProps> = withLayout(
    TextFieldComponent({
      useAppSelector,
    }),
  );
  const SingleProduct: ComponentConfig<SingleProductProps> = withLayout(
    ProductComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const Quantity: ComponentConfig<QuantityProps> = withLayout(
    QuantityComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const Star: ComponentConfig<StarProps> = withLayout(
    Startrate({
      useAppSelector,
    }),
  );
  const CarouselReview: ComponentConfig<CarouselReviewProps> = withLayout(
    CarouselReviewComponent({
      useAppSelector,
      baseService,
    }),
  );
  // const Slidercomponent: ComponentConfig<ReviewProps> = withLayout(
  //   ReviewSlider({
  //     useAppSelector,
  //     baseService,
  //   }),
  // );
  const VipComponent: ComponentConfig<VipComponentProps> = withLayout(
    Vip({
      useAppSelector,
    }),
  );
  const GeneralTerms: ComponentConfig<GeneralTermsProps> = withLayout(
    General({
      useAppSelector,
    }),
  );
  const TermsAndSub: ComponentConfig<TermsAndSubProps> = withLayout(
    TermsAndSubComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );

  const CheckBoxComponent: ComponentConfig<CheckBoxProps> = withLayout(
    CheckBox({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const ShippingMethodSelect: ComponentConfig<ShippingMethodSelectProps> =
    withLayout(
      ShippingMethodSelectComponent({
        useAppSelector,
        useAppDispatch,
      }),
    );
  const SavingCalculator: ComponentConfig<SavingCalculatorProps> = withLayout(
    SavingCalculatorComponent({
      useAppSelector,
    }),
  );
  const PromoCode: ComponentConfig<PromoCodeProps> = withLayout(
    PromoCodeComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const Payment: ComponentConfig<PaymentProps> = withLayout(
    PaymentComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const PaymentRadio: ComponentConfig<PaymentRadioProps> = withLayout(
    PaymentRadioComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const OrderDetails: ComponentConfig<OrderDetailsProps> = withLayout(
    OrderDetailsComponent({
      useAppSelector,
    }),
  );
  const OrderSummary: ComponentConfig<OrderSummaryProps> = withLayout(
    OrderSummaryComponent({
      useAppSelector,
    }),
  );
  const PostUpsellOrderSummary: ComponentConfig<PostUpsellOrderSummaryProps> =
    withLayout(
      PostUpsellOrderSummaryComponent({
        useAppSelector,
      }),
    );

  const ContactInfo: ComponentConfig<ContactInfoProps> = withLayout(
    ContactInfoComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const Cart: ComponentConfig<CartProps> = withLayout(
    CartComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const SimplePageHeader: ComponentConfig<SimplePageHeaderProps> = withLayout(
    SimplePageHeaderComponent({
      useAppSelector,
      baseService,
    }),
  );
  const HeaderMenu: ComponentConfig<HeaderMenuProps> = withLayout(
    HeaderMenuComponent({
      useAppSelector,
      baseService,
    }),
  );
  const ConfirmPurchase: ComponentConfig<SingleStepButtonSectionProps> =
    withLayout(
      ConfirmPurchaseComponent({
        useAppSelector,
        useAppDispatch,
        baseService,
      }),
    );
  const ApplePayButton: ComponentConfig<ApplePayButtonProps> = withLayout(
    ApplePayButtonComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const GooglePayButton: ComponentConfig<GooglePayButtonProps> = withLayout(
    GooglePayButtonComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const PayPalButton: ComponentConfig<PayPalButtonProps> = withLayout(
    PayPalComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const ConfirmPurchaseTC: ComponentConfig<ConfirmPurchaseTCProps> = withLayout(
    ConfirmPurchaseTCComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const ReturnButton: ComponentConfig<ReturnButtonProps> = withLayout(
    ReturnButtonComponent({
      useAppSelector,
    }),
  );
  const SingleProductAcceptButton: ComponentConfig<SingleProductAcceptButtonProps> =
    withLayout(
      SingleProductAcceptButtonComponent({
        useAppSelector,
        useAppDispatch,
        baseService,
      }),
    );
  const Button: ComponentConfig<ButtonSectionProps> = withLayout(
    ButtonComponent({
      baseService,
      useAppSelector,
    }),
  );
  const CustomerGuarantees: ComponentConfig<CustomerGuarnteesProps> =
    CustomerGuarnteesComponent({
      baseService,
      useAppSelector,
    });
  const ImageUploader: ComponentConfig<ImageUploaderProps> =
    ImageUploaderComponent({
      baseService,
      useAppSelector,
    });
  const DeclineButton: ComponentConfig<DeclineButtonProps> = withLayout(
    NextButtonComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const MultiProductAcceptButton: ComponentConfig<MultiProductAcceptButtonComponentPropsProps> =
    withLayout(
      MultiProductAcceptButtonComponent({
        useAppSelector,
        useAppDispatch,
        baseService,
      }),
    );
  const CustomerReviews: ComponentConfig<CustomerReviewsProps> = withLayout(
    CustomerReviewsComponent({
      useAppSelector,
      baseService,
    }),
  );
  const Timer: ComponentConfig<TimerProps> = withLayout(
    TimerComponent({
      useAppSelector,
    }),
  );
  const NewTimer: ComponentConfig<NewTimerProps> = withLayout(
    NewTimerComponent({
      useAppSelector,
    }),
  );
  const AlwaysVip: ComponentConfig<AlwaysVipProps> = withLayout(
    AlwaysVipComponent({
      useAppSelector,
    }),
  );
  const ShippingForm: ComponentConfig<ShippingForm> = withLayout(
    ShippingFormComponent({ useAppSelector, useAppDispatch }),
  );

  const FirstLastName: ComponentConfig<FirstLastNameProps> = withLayout(
    FirstLastNameComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );

  const PhoneNumber: ComponentConfig<PhoneNumberFieldProps> = withLayout(
    PhoneNumberFieldComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const StandardLayout: ComponentConfig<StandardLayoutProps> = withLayout(
    StandardLayoutComponent({
      useAppSelector,
    }),
  );
  const SplitLayout: ComponentConfig<SplitLayoutProps> = withLayout(
    SplitLayoutComponent({
      useAppSelector,
    }),
  );

  const BillingFormComponent: ComponentConfig<BillingFormProps> = withLayout(
    BillingForm({
      useAppSelector,
    }),
  );

  const UserDetailsComponent: ComponentConfig<UserSectionProps> = withLayout(
    UserComponent({
      useAppSelector,
    }),
  );

  const FooterComponent: ComponentConfig<FooterProps> = withLayout(
    Footer({
      useAppSelector,
    }),
  );

  const SocialMedia: ComponentConfig<SocialMediaProps> = withLayout(
    SocialMediaIcon({
      useAppSelector,
      baseService,
    }),
  );

  const ShippmentUpSell: ComponentConfig<ShipmentUpSellProps> = withLayout(
    ShipmentUpSell({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const TermsAndCondition: ComponentConfig<TermsAndConditionProps> = withLayout(
    TermsAndConditionComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const TextBannerComponent: ComponentConfig<TextBannerProps> = withLayout(
    TextBanner({
      useAppSelector,
    }),
  );
  const VideoPlayerComponent: ComponentConfig<VideoPlayerProps> = withLayout(
    VideoPlayer({
      useAppSelector,
      baseService,
    }),
  );
  const NewsLetter: ComponentConfig<NewsLetterFieldProps> = withLayout(
    NewsLetterComponent({
      useAppSelector,
    }),
  );
  const ProductVariantSelection: ComponentConfig<ProductVarientSelectionProps> =
    withLayout(
      ProductVariantSelectionComponent({
        useAppSelector,
        useAppDispatch,
      }),
    );
  const TabContent: ComponentConfig<TabContentProps> = withLayout(
    TabContentComponent({
      useAppSelector,
    }),
  );
  const FAQDisclosureSection: ComponentConfig<FAQDisclosureSectionProps> =
    withLayout(
      FAQDisclosureSectionComponent({
        useAppSelector,
      }),
    );
  const MultiProduct: ComponentConfig<MultiProductProps> = withLayout(
    ProductCardComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );

  const CarouselPanelComponent: ComponentConfig<CarouselPanelProps> =
    withLayout(
      CarouselPanel({
        useAppSelector,
      }),
    );

  const CarouselContainer: ComponentConfig<CarouselContainerProps> = withLayout(
    CarouselContainerComponent({
      useAppSelector,
    }),
  );

  const Predefined: ComponentConfig<PredefinedProps> = withLayout(
    PredefinedComponent({ useAppSelector, baseService, useAppDispatch }),
  );
  const PredefinedUpsell: ComponentConfig<PredefinedPropsForUpsell> =
    withLayout(
      PredefinedComponentForUpsell({
        useAppSelector,
        baseService,
        useAppDispatch,
      }),
    );

  const GoogleMapComponent: ComponentConfig<GoogleMapProps> = withLayout(
    GoogleMap({ useAppDispatch, useAppSelector }),
  );

  const HoverTooltipComponent: ComponentConfig<HoverTooltipProps> = withLayout(
    HoverTooltip({ useAppDispatch, useAppSelector }),
  );

  const GiftProductTimer: ComponentConfig<GiftProductTimerProps> = withLayout(
    GiftProductTimerComponent({
      useAppSelector,
      useAppDispatch,
      baseService,
    }),
  );
  const TextDropdown: ComponentConfig<TextDropdownProps> = withLayout(
    TextDropdownComponent({
      useAppSelector,
      baseService,
    }),
  );
  const SMSMarketing: ComponentConfig<SMSMarketingProps> = withLayout(
    SMSMarketingComponent({
      useAppSelector,
      useAppDispatch,
    }),
  );
  const CarouselImage: ComponentConfig<CarouselImageProps> = withLayout(
    CarouselImageComponent({
      useAppSelector,
      baseService,
    }),
  );

  const CustomHTML: ComponentConfig<CustomHTMLProps> = withLayout(
    CustomHTMLComponent({
      useAppSelector,
    }),
  );
  const TicketsEntryMultiplier: ComponentConfig<TicketsEntryMultiplierProps> =
    withLayout(
      TicketsEntryMultiplierComponent({
        useAppSelector,
        useAppDispatch,
      }),
    );
  const configComponents = {
    checkout: {
      BillingFormComponent,
      CustomerReviews,
      Timer,
      NewTimer,
      UpSell,
      VipComponent,
      ConfirmPurchase,
      ApplePayButton,
      GooglePayButton,
      PayPalButton,
      ConfirmPurchaseTC,
      ReturnButton,
      StandardLayout,
      CustomerGuarantees,
      Payment,
      TermsAndSub,
      ShippingMethodSelect,
      SplitLayout,
      AlwaysVip,
      ShippingForm,
      FirstLastName,
      PhoneNumber,
      SavingCalculator,
      HeaderMenu,
      PaymentRadio,
      OrderDetails,
      Cart,
      PromoCode,
      ContactInfo,
      ShippmentUpSell,
      CarouselReview,
      TermsAndCondition,
      CheckBoxComponent,
      CarouselPanelComponent,
      CarouselContainer,
      NewsLetter,
      Predefined,
      GiftProductTimer,
      TextDropdown,
      HoverTooltipComponent,
      SMSMarketing,
      CarouselImage,
      TicketsEntryMultiplier,
    },
    thankyou: {
      HeaderMenu,
      UserDetailsComponent,
      OrderSummary,
      PostUpsellOrderSummary,
      GoogleMapComponent,
    },
    upsell: {
      Header,
      SingleProduct,
      SingleProductAcceptButton,
      MultiProduct,
      Timer,
      NewTimer,
      DeclineButton,
      MultiProductAcceptButton,
      // Slidercomponent,
      Star,
      ProductVariantSelection,
      TabContent,
      FAQDisclosureSection,
      Quantity,
      CarouselReview,
      CarouselPanelComponent,
      CarouselContainer,
      CarouselImage,
      TextDropdown,
      PredefinedUpsell,
    },
    common: {
      // These are the common components that are used in all pages
      Columns,
      Grid,
      Flex,
      NewFlex,
      Accordion,
      GeneralTerms,
      VerticalSpace,
      Divider,
      Container,
      ImageUploader,
      Button,
      TextEditor,
      TextField,
      SimplePageHeader,
      FooterComponent,
      SocialMedia,
      TextBannerComponent,
      VideoPlayerComponent,
      CustomHTML,
    },
  };
  let config = {};

  if (type === 'checkout') {
    config = configComponents.checkout;
  } else if (type === 'thankyou') {
    config = configComponents.thankyou;
  } else if (type === 'upsell') {
    config = configComponents.upsell;
  } else if (type === 'all') {
    config = {
      ...configComponents.checkout,
      ...configComponents.upsell,
      ...configComponents.thankyou,
    };
  }
  config = {
    ...config,
    ...configComponents.common,
  };
  return config;
};
